import styled from "styled-components";

export const STitleWithTooltipTitle = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none;
`;
